import React from 'react';
import PropTypes from 'prop-types';

const MainTmps = ({children}) => <div className="MainTmps">{children}</div>;

MainTmps.prototype = { children: PropTypes.children };

export default MainTmps;
